import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnticipation = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.875 7.31519L5.90055 9.34074L9.88497 6.83712C10.7797 6.27489 11.3228 5.29229 11.3228 4.23554V3.87363C11.3228 3.29047 11.0911 2.73119 10.6788 2.31883C10.2664 1.90647 9.70714 1.6748 9.12397 1.6748H8.83975C7.81682 1.6748 6.87038 2.21647 6.35223 3.09846L3.875 7.31519Z",
			fill: "#8C81F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.20706 3.63081C8.80149 3.48695 9.39938 3.85429 9.53986 4.44944C9.68026 5.0446 9.30962 5.64048 8.71366 5.77758C8.12245 5.91355 7.53236 5.54654 7.39301 4.95605C7.25366 4.36556 7.61737 3.77346 8.20706 3.63081Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.44545 8.72626C2.74342 8.28407 3.26834 8.03449 3.79158 8.13713C4.25499 8.22803 4.64259 8.47733 4.85256 9.02713C4.98652 9.36903 4.97581 9.75069 4.82302 10.0845C4.55398 10.6589 4.07708 10.7986 3.52982 11.0049C3.10678 11.1286 2.21835 11.4398 1.82663 11.2779C1.42823 10.7415 1.90901 9.52232 2.44545 8.72626Z",
			fill: "#D1CDFC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.3601 8.29492L8.45984 8.40473C8.51112 9.34774 8.18283 10.6645 7.26896 11.1211C6.97521 11.0926 7.04822 11.0831 6.78554 10.84C6.57648 10.591 6.1866 9.9635 5.99219 9.66604C6.81815 9.25129 7.60136 8.82407 8.3601 8.29492Z",
			fill: "#D1CDFC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.94531 4.80787L4.83551 4.70813C3.8925 4.65685 2.57572 4.98514 2.1191 5.89901C2.1476 6.19276 2.15718 6.11975 2.40022 6.38243C2.64921 6.59149 3.27673 6.98137 3.57419 7.17578C3.98894 6.34982 4.41617 5.56661 4.94531 4.80787Z",
			fill: "#D1CDFC"
		})
	]
});
export default SvgAnticipation;
